/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react"
import { SuccessFetch } from "types"
import { useApi } from "utils"
import { PostingYearlyList } from "../types"

type UsePostingYearlyList = {
  page?: number
  limit?: number
  onSuccess?: (data: PostingYearlyList[]) => void
}

type Response = {
  payload: {
    items: PostingYearlyList[]
  }
}

export function usePostingYearlyList({ onSuccess }: UsePostingYearlyList) {
  const api = useApi()
  const [data, setData] = useState<PostingYearlyList[]>([])
  const [isLoading, setLoading] = useState(false)

  const fetchData = () => {
    setLoading(true)

    api
      .get("/postingyearly/")
      .then((res: SuccessFetch<Response>) => {
        const data = res.data.payload?.items ?? []

        onSuccess?.(data)
        setData(data)
      })
      .catch(() => setData([]))
      .finally(() => setLoading(false))
  }

  const refetch = () => fetchData()

  useEffect(() => {
    fetchData()

    return () => {
      setData([])
      setLoading(false)
    }
  }, [])

  return { data, isLoading, refetch }
}
